/** Papel do usuário no vínculo (POST vincular-pessoa-representacao-negocio — `papelPessoaSecundario`) */
export const REPRESENTATIVE_USER_ROLE_OPTIONS = [
  { label: 'ESTIPULANTE', value: '9' },
  { label: 'SUB-ESTIPULANTE', value: '10' },
] as const;

export const DEFAULT_REPRESENTATIVE_USER_ROLE_CODE = '9';

export type RepresentativeUserRoleCode = (typeof REPRESENTATIVE_USER_ROLE_OPTIONS)[number]['value'];

export function isRepresentativeUserRoleCode(value: string): value is RepresentativeUserRoleCode {
  return value === '9' || value === '10';
}
